// TODO: to delete
import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "NOTIFICATION_UPDATE_ERROR":
            return action.error;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "NOTIFICATION_UPDATE_LOADING":
            return action.loading;

        default:
            return state;
    }
}

export function success(state = false, action) {
    switch (action.type) {
        case "NOTIFICATION_UPDATE_SUCCESS":
            return action.success;

        default:
            return state;
    }
}

export default combineReducers({error, loading, success});
